export const invoicesMisc = {
  sendLink: {
    title: "Invia link della fattura",
    already: {
      title: "Questa prenotazione ha già una fattura emessa.",
      onlyOne: "È consentita solo <b>1 fattura per prenotazione</b>.",
      offerPdf:
        "Se vuoi, possiamo inviarti subito il PDF della fattura via WhatsApp.",
    },
    openPdf: "Apri PDF",
    sendWhatsapp: "Invia fattura via WhatsApp",
    sending: "Invio in corso...",
    info: {
      title: "Il link della fattura verrà inviato all'ospite via WhatsApp.",
      desc: "L'ospite completerà i propri dati fiscali dal link e potrà scaricare la propria fattura elettronica.",
    },
    rule: "<strong>Regola:</strong> è possibile emettere solo <b>1 fattura per prenotazione</b>.",
    accept: "Accetta e invia",
    toast: {
      invoiceSent: "Fattura inviata via WhatsApp.",
      linkSent: "Link della fattura inviato via WhatsApp.",
    },
    warn: {
      noReservation: "L'ID della prenotazione non è ancora stato trovato.",
    },
    err: {
      sendInvoiceFailed: "Impossibile inviare la fattura via WhatsApp.",
      sendLinkFailed: "Impossibile inviare il link.",
    },
  },
  country: {
    placeholder: "Seleziona un paese (facoltativo)",
    noResult: "Nessun risultato",
  },
  adjust: {
    title: "Modifica {name}",
    type: {
      apartment: "Appartamento/i",
      hotel: "Hotel (camere)",
      villa: "Ville",
      camping: "Piazzole",
      default: "Alloggi",
    },
    usage: "Utilizzo attuale",
    available: "Disponibili",
    unitDefault: "unità",
    hintReduce:
      "La riduzione viene applicata subito e <b>non</b> genera alcun rimborso. Pagherai meno nella prossima fattura.",
    unitPriceCurrent: "Prezzo unitario attuale",
    totalBeforeProration: "Totale (prima del calcolo proporzionale)",
    prorationNote:
      "Verrà applicato un <b>calcolo proporzionale</b> per i giorni trascorsi nel ciclo.",
    confirmIncrease: "Conferma aumento",
    confirmDecrease: "Conferma riduzione",
    err: {
      selectAmount: "Seleziona una quantità da modificare.",
      failed: "Impossibile completare l'operazione.",
    },
    toast: {
      added: "Unità aggiunte",
      reduced: "Unità ridotte",
      addedDetail: "Verrà applicato un calcolo proporzionale per i giorni rimanenti del ciclo.",
      reducedDetail: "Pagherai meno nella prossima fattura (nessun rimborso).",
    },
  },
  menu: {
    title: "Il mio abbonamento",
    subtitle: "Gestisci i tuoi abbonamenti, le fatture e i metodi di pagamento",
    subscription: "Il mio abbonamento",
    paymentMethod: "Metodo di pagamento",
    invoices: "Fatture",
  },
  custom: {
    title: "Piano personalizzato",
    whatDoYouNeed: "Di cosa hai bisogno?",
    salesContact:
      "Il nostro team commerciale ti contatterà il prima possibile.",
    tellUs: "Raccontaci di più sul tuo progetto",
    sentOk: "Inviato con successo",
    salesContactShort:
      "Il team commerciale ti contatterà il prima possibile",
    contactSales: "Contatta il team commerciale",
    err: {
      required:
        "Devi specificare di cosa hai bisogno affinché possiamo contattarti",
      failed: "Spiacenti, non è stato possibile elaborare la richiesta",
    },
  },
  common: {
    cancel: "Annulla",
    close: "Chiudi",
  },
};
